import { STATUS_SPECS } from '../actionTypes';

export const setStatusData = action => ({
  type: STATUS_SPECS.SET_STATUS_DATA,
  payload: action.payload,
});
